<template>
    <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0.833008C11.958 0.833008 15.167 4.04196 15.167 8C15.167 11.958 11.958 15.167 8 15.167C4.04196 15.167 0.833008 11.958 0.833008 8C0.833008 4.04196 4.04196 0.833008 8 0.833008ZM10.5303 5.46973C10.2374 5.17683 9.76262 5.17683 9.46973 5.46973L8 6.93945L6.53027 5.46973C6.23738 5.17683 5.76262 5.17683 5.46973 5.46973C5.17683 5.76262 5.17683 6.23738 5.46973 6.53027L6.93945 8L5.46973 9.46973C5.17683 9.76262 5.17683 10.2374 5.46973 10.5303C5.76262 10.8232 6.23738 10.8232 6.53027 10.5303L8 9.06055L9.46973 10.5303L9.52637 10.582C9.82095 10.8223 10.2557 10.8049 10.5303 10.5303C10.8049 10.2557 10.8223 9.82095 10.582 9.52637L10.5303 9.46973L9.06055 8L10.5303 6.53027C10.8232 6.23738 10.8232 5.76262 10.5303 5.46973Z" fill="#888888"/>
    </svg>
</template>

<script>
export default {
    name: 'CloseTransIcon',
    props: {
        width: {
            type: [Number, String],
            default: () => 16,
        },
        height: {
            type: [Number, String],
            default: () => 16,
        },
    },
}
</script>
